import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface AccountancySendEmailSingleCommandParams {
    id: number;
    recipients: string[];
    compress: boolean;
    password?: string;
    mailTemplateSubject: string;
    mailTemplateContent: string;
    senderName: string;
}

export type AccountancySendEmailSingleCommandResult = null;

export class AccountancySendEmailSingleCommand extends Command<AccountancySendEmailSingleCommandParams, void> { }

export class AccountancySendEmailSingleCommandHandlerBase implements CommandHandler<AccountancySendEmailSingleCommand, AccountancySendEmailSingleCommandParams, void> {
    private static Url = TaggedUrl.join('/accounting/:id/email', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync({ params }: AccountancySendEmailSingleCommand): Promise<void> {
        const url = fillPlaceholders(AccountancySendEmailSingleCommandHandlerBase.Url, { id: params?.id });
        await this.http.post<AccountancySendEmailSingleCommandResult>(url, { ...params });
    }
}
